import Base from './base'
import renderFields from './push-event.pug'

export default class PushEvent extends Base
  @label: "伺服器觸發"

  renderFields: renderFields
